module.exports = __webpack_public_path__ + "img/icon_engineering_machinery.8c28dfc7.png";